module.exports = __webpack_public_path__ + "static/media/stockhausen_nowald_13.1579d869.jpeg";